/**
 * Persistencia del token de desbloqueo del sitio.
 *
 * Guarda el token, nunca el código. El valor guardado no decide nada por sí
 * solo: el backend lo revalida en cada carga (ver `site-access-client.ts`).
 *
 * Todo va envuelto en try/catch porque `localStorage` tira cuando el navegador
 * bloquea el almacenamiento (modo privado, cookies de terceros deshabilitadas).
 * En ese caso el visitante escribe el código una vez por sesión de pestaña, que
 * es peor experiencia pero no una pantalla rota.
 */

const STORAGE_KEY = 'sica.site-access.token';

export function readAccessToken(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeAccessToken(token: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Sin almacenamiento el desbloqueo dura lo que dura la vista en memoria.
  }
}

export function clearAccessToken(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nada que limpiar si nunca se pudo escribir.
  }
}
